.wrap {
  padding: 56px 22px 0;
  text-align: center;
}
.title {
  margin: 0;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 24px;
  letter-spacing: 7px;
  text-indent: 7px;
  color: var(--ink-2);
}
.subtitle {
  margin-top: 8px;
  font-family: var(--font-detail);
  font-size: 13px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 0.5px;
  color: var(--muted-3);
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* dense를 쓰면 가로 사진 앞의 빈칸에 이후 사진이 끼어들어 번호 순서가 바뀐다. */
  grid-auto-flow: row;
  gap: 16px;
  margin-top: 28px;
}
.tile {
  display: block;
  width: 100%;
  align-self: start;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid rgba(60, 50, 30, 0.06);
  border-radius: 3px;
  padding: 8px 8px 26px;
  box-shadow:
    0 1px 2px rgba(60, 50, 30, 0.06),
    0 7px 16px rgba(90, 75, 50, 0.1);
  box-sizing: border-box;
  font: inherit;
  text-align: inherit;
  color: inherit;
}
.frame {
  display: block;
  position: relative;
  border-radius: 1px;
  overflow: hidden;
  background: #f1ecdf;
  color: var(--muted-5);
}
.photo {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}
.counter {
  margin-top: 14px;
  font-family: var(--font-detail);
  font-size: 11.5px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 1.5px;
  color: var(--muted-3);
}
.more {
  composes: tapTarget from '../styles/tapTarget.module.css';
  margin-top: 12px;
  border: none;
  border-bottom: 1px solid #aab4be;
  border-radius: 0;
  background: none;
  padding: 4px 6px 7px;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 17px;
  letter-spacing: 3px;
  color: var(--ink-5);
  cursor: pointer;
}
